import PropTypes from 'prop-types';
import React from 'react';
import TopCompany from '../TopCompany/TopCompany';

import './TopCompanies.scss';

export default class TopCompanies extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        topCompanies: PropTypes.arrayOf(
            PropTypes.shape({
                position: PropTypes.string,
                average: PropTypes.number,
                logo: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.number,
                }),
                companyId: PropTypes.number,
                companyName: PropTypes.string,
                companyUrl: PropTypes.string,
                isFollowed: PropTypes.bool,
            })
        ),
    };

    static defaultProps = {
        topCompanies: [],
    };

    renderCompanies = () => {
        if (!this.props.topCompanies) {
            return null;
        }

        return this.props.topCompanies.map((company, idx) => (
            <TopCompany
                key={idx}
                logo={company.logo}
                companyId={company.companyId}
                companyName={company.position.concat(
                    '. ' + company.companyName
                )}
                companyUrl={company.companyUrl}
                isFollowed={company.isFollowed}
                average={company.average}
            />
        ));
    };

    render() {
        return (
            <div className="component-Ratings-TopCompanies">
                {this.renderCompanies()}
            </div>
        );
    }
}
